import TrashIcon from "@icons/TrashIcon.svg?react";
import { SvgImageSwap } from "../../../display-items/SVGIcon";

function DeleteButton({ onClick, type }: { onClick: any; type?: "small" }) {
  return (
    <button
      className={`${
        type === "small" ? "iconButton" : "iconButton__alt"
      }  bg_red300 delete-button`}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      type="button"
    >
      <SvgImageSwap
        src={TrashIcon}
        alt="Delete Icon"
        className={`${type === "small" ? "icon__mid" : "icon"} fill_red_800`}
      />
    </button>
  );
}

export default DeleteButton;
